import { Avatar, Grid, Typography } from "@mui/material";
import { AppImages } from "app/appImages";
import { MprcContainer, MprcLink } from "components";
import { UserSearchDto } from "generated/CoreApi_v1";
import * as React from "react";
import { Link } from "react-router";
import { RootPaths } from "routes/RootRouter";
import { UserProfileDialog } from "views/foundation/user/dialogs/UserProfileDialog";

/////////////////////////////////////////////////////////////////////////////////////////////////

interface IProps {
    data: UserSearchDto;
    onBeforeLinkClick?: () => void;
}

/////////////////////////////////////////////////////////////////////////////////////////////////

export const SearchRenderUser: React.FC<IProps> = (props) => {
    const { data, onBeforeLinkClick } = props;
    const navUrl = RootPaths.BuildUserProfile(data.userId);
    const [dialog, setDialog] = React.useState<any>(null);

    return (
        <>
            {dialog}
            <MprcContainer>
                <Grid container spacing={1}>
                    <Grid>
                        <MprcLink
                            onClick={() => setDialog(
                                <UserProfileDialog
                                    userId={data.userId}
                                    onClose={() => setDialog(null)}
                                    onBeforeLinkClick={onBeforeLinkClick}
                                />
                            )}
                        >
                            <Avatar
                                src={data.thumbnailUrl ?? AppImages.UserThumbnail}
                                alt={data.name}
                                title={data.name}
                                sx={{ width: 48, height: 48 }}
                            />
                        </MprcLink>
                    </Grid>
                    <Grid size="grow" alignSelf="center">
                        <Link to={navUrl}>
                            <Link
                                onClick={onBeforeLinkClick}
                                to={navUrl}
                            >
                                <Typography variant="h6" component="div" color="primary.main">
                                    {data.name}
                                </Typography>
                            </Link>
                        </Link>
                        <Typography variant="caption" component="div">
                            {data.jobPositionName}
                        </Typography>
                    </Grid>
                </Grid>
            </MprcContainer>
        </>
    );
};
